var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Generated by `npm run icon`, don't modify this file
import React from 'react';
import Base from './_base';
const InfoCircle = props => {
    const { className = null } = props, other = __rest(props, ["className"]);
    return (<Base viewBox="0 0 16 16" className={`cuk2-icon-info_circle ${className}`} {...other}>
      <g>
        <path d="M8 0a8 8 0 110 16A8 8 0 018 0zm0 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zm.25 5a.5.5 0 01.492.41L8.75 7 9 12a.5.5 0 01-.41.492l-.09.008h-1a.5.5 0 01-.492-.41L7 12l.25-5a.5.5 0 01.41-.492l.09-.008h.5zM8 3.36A1.07 1.07 0 118 5.5a1.07 1.07 0 010-2.14z" fillRule="evenodd"/>
      </g>
    </Base>);
};
export default InfoCircle;
